import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Advantages } from './components/Advantages';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Courses } from './components/Courses';
import { About } from './components/About';
import { Reviews } from './components/Reviews';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { PromoBanner } from './components/PromoBanner';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  useEffect(() => {
    document.title = 'Сайт створено';
  }, []);
  return <div className="font-sans text-dark bg-white selection:bg-accent selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Advantages data-id="element-4" />
        <Services data-id="element-5" />
        <Gallery data-id="element-6" />
        <Courses data-id="element-7" />
        <About data-id="element-8" />
        <Reviews data-id="element-9" />
        <CTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <PromoBanner data-id="element-12" />
    </div>;
}